import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncWithdrawContractDashboard = loadable(
  () => import('./DashboardWithdraw'),
  { fallback: <Loader /> },
);
